import { render, staticRenderFns } from "./CreateTelnyxChannel.vue?vue&type=template&id=8798a3a6&scoped=true"
import script from "./CreateTelnyxChannel.vue?vue&type=script&lang=js"
export * from "./CreateTelnyxChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateTelnyxChannel.vue?vue&type=style&index=0&id=8798a3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8798a3a6",
  null
  
)

export default component.exports